import Link from "next/link";
import Partners from "./Partners";

const HomeBanner = () => {
  return (
    <section className="banner-section">
      <div className="overlay">
        <div className="banner-content d-flex align-items-center">
          <div className="container">
            <div className="row justify-content-start">
              <div className="col-lg-7 col-md-10">
                <div className="main-content">
                  <div className="top-area section-text justify-content-center">
                    <h5 className="sub-title">AUTHORIZED MONEY CHANGER</h5>
                    <h4 className="title">PT. CEMARA JAYA VALASINDO </h4>
                    <p className="xlr">
                      Perusahaan penukaran mata uang asing yang sudah berlisensi dan terpercaya,
                      kunjungi kami di Jalan Boulevard Raya no 8 AM, kompleks Cemara Asri, Kel. Sampali, kec. Percut Sei Tuan.
                      No Telp: +62-821-7820-8800
                    </p>
                  </div>
                  <div className="bottom-area">
                    <Link href="/currency-rate" className="cmn-btn">
                      Kurs Hari ini
                    </Link>
                    { /*}
                    <Link href="/register" className="cmn-btn">
                      Open Account
                    </Link>
                    */ }
                    <Link href="/contact" className="cmn-btn second">
                      Hubungi Kami
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      { /* Partners slider here *
      <Partners />
      */}
    </section>
  );
};

export default HomeBanner;
